import { useState } from "react";

const NAV = [
  { label: "今日快讯", href: "#flash" },
  { label: "最新爆料", href: "#stream" },
  { label: "新瓜热榜", href: "#hot" },
  { label: "题材合集", href: "#topic" },
  { label: "事件追踪", href: "#track" },
];

export default function TopBar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-background-200/80 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex w-full max-w-[1280px] items-center gap-4 px-4 py-3 md:px-6">
        {/* brand */}
        <a href="#top" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-600 text-background-50">
            <i className="ri-fire-fill text-lg" />
          </span>
          <span className="leading-none">
            <span className="font-heading block text-lg font-black tracking-wide text-foreground-950">
              新黑料网
            </span>
            <span className="block text-[11px] tracking-widest text-foreground-500">每日全网爆料速递</span>
          </span>
        </a>

        {/* desktop nav */}
        <nav className="ml-auto hidden items-center gap-1 md:flex">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-600 transition-colors hover:bg-background-100 hover:text-primary-700"
            >
              {n.label}
            </a>
          ))}
        </nav>

        {/* search */}
        <div className="hidden w-48 items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-1.5 lg:flex xl:w-56">
          <i className="ri-search-line flex items-center justify-center text-foreground-400" />
          <input
            type="text"
            placeholder="搜某瓜、某事件"
            className="w-full bg-transparent text-sm text-foreground-700 outline-none placeholder:text-foreground-400"
          />
        </div>

        {/* download cta */}
        <a
          href="#download"
          className="hidden shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700 md:inline-flex"
        >
          <i className="ri-download-2-line text-sm" />
          客户端
        </a>

        {/* mobile toggle */}
        <button
          type="button"
          aria-label="菜单"
          onClick={() => setOpen((v) => !v)}
          className="ml-auto flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-700 md:hidden"
        >
          <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
        </button>
      </div>

      {/* mobile menu */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="mb-3 flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-2">
            <i className="ri-search-line text-foreground-400" />
            <input
              type="text"
              placeholder="搜某瓜、某事件"
              className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
            />
          </div>
          <div className="grid grid-cols-2 gap-1">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2 text-sm text-foreground-700 hover:bg-background-100"
              >
                {n.label}
              </a>
            ))}
          </div>
          <a
            href="#download"
            onClick={() => setOpen(false)}
            className="mt-3 inline-flex w-full items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-600 px-4 py-2.5 text-sm font-medium text-background-50"
          >
            <i className="ri-download-2-line text-sm" />
            下载客户端，第一时间吃瓜
          </a>
        </div>
      )}
    </header>
  );
}